import React from 'react'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import {companyPath} from '../../public/PublicModels'
import {ICorporateModel} from './CorporateModel'

type Props = {
  data: ICorporateModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit: (corporate: ICorporateModel) => void
  onUsers: (corporate: ICorporateModel) => void
  onToggleActive: (corporate: ICorporateModel) => void
  onDelete: (corporate: ICorporateModel) => void
  loading?: boolean
}

export const CorporateTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onUsers,
  onToggleActive,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<ICorporateModel>[] = [
    {
      key: 'name',
      label: 'Firma',
      render: (_, corporate) => (
        <div className='d-flex flex-column'>
          <span className='fw-bolder text-gray-800'>{corporate.name}</span>
          {corporate.slug && (
            <a
              href={companyPath(corporate.slug)}
              target='_blank'
              rel='noopener noreferrer'
              className='text-muted text-hover-primary fs-7'
            >
              {companyPath(corporate.slug)}
            </a>
          )}
        </div>
      ),
    },
    {
      key: 'taxNumber',
      label: 'Vergi No / Dairesi',
      render: (_, corporate) => (
        <div className='d-flex flex-column fs-7'>
          <span>{corporate.taxNumber || '-'}</span>
          <span className='text-muted'>{corporate.taxOffice}</span>
        </div>
      ),
    },
    {
      key: 'email',
      label: 'İletişim',
      render: (_, corporate) => (
        <div className='d-flex flex-column fs-7'>
          <span>{corporate.email || '-'}</span>
          <span className='text-muted'>{corporate.phone}</span>
        </div>
      ),
    },
    {
      key: 'active',
      label: 'Durum',
      width: '90px',
      render: (active: boolean) =>
        active ? (
          <span className='badge badge-light-success'>Aktif</span>
        ) : (
          <span className='badge badge-light-secondary'>Pasif</span>
        ),
    },
  ]

  const actions: TableAction<ICorporateModel>[] = [
    {
      label: 'Kullanıcılar',
      icon: 'bi bi-people',
      className: 'btn-light-info me-2',
      onClick: onUsers,
    },
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Pasife Al',
      icon: 'bi bi-pause-circle',
      className: 'btn-light-warning me-2',
      onClick: onToggleActive,
      condition: (corporate) => corporate.active,
    },
    {
      label: 'Aktifleştir',
      icon: 'bi bi-play-circle',
      className: 'btn-light-success me-2',
      onClick: onToggleActive,
      condition: (corporate) => !corporate.active,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz firma bulunamadı'
    />
  )
}
